import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dateDEShort'
})
export class DEDatePipeShort implements PipeTransform {

  constructor(private datePipe: DatePipe = new DatePipe('de-DE')) {

  }

  transform(value: any, _format?: string, _timezone?: string): any {
    return this.datePipe.transform(value, 'mediumDate','CET');
  }  
}
